import React from 'react';
import { ClientEngagementNoMatchMessage } from '@axiom/const';

import NoResults from '../../../public/static/svg/man-walking.svg';
import { Layout } from '../../layout/Layout/Layout';
import { LargeHeader } from '../../content/LargeHeader/LargeHeader';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Visible } from '../../layout/Visible/Visible';

export const ClientEngagementSelfServiceNoTalentMessage = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Layout
      background="panelLight"
      boxShadow="default"
      direction="horizontal"
      name="self-service-no-matches"
      borderRadius="16px"
    >
      <Visible only="largeScreen" name="no-instant-matches-graphic">
        <NoResults width={256} height={256} />
      </Visible>
      <Gutter vertical="32px" horizontal="24px">
        <LargeHeader name="self-service-no-profile-header">
          {ClientEngagementNoMatchMessage.title}
        </LargeHeader>
        <Gutter top="16px">
          <Paragraph name="self-service-no-profile-content">
            {ClientEngagementNoMatchMessage.content} Want to explore other
            options right now?
          </Paragraph>
          <Gutter top="16px">{children}</Gutter>
        </Gutter>
      </Gutter>
    </Layout>
  );
};
